module.exports = __webpack_public_path__ + "static/media/pressure.cb6890dd.png";